var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFactsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 112,
    height: 112,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 112,
    height: 112,
    rx: 16,
    stroke: "#E1E8FA",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8754_33478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4611 52.4209H30.8816C29.1228 52.4209 27.436 53.1196 26.1923 54.3632C24.9487 55.6069 24.25 57.2937 24.25 59.0525C24.25 60.8113 24.9487 62.4981 26.1923 63.7417C27.436 64.9854 29.1228 65.6841 30.8816 65.6841H32.2742V67.5788H36.0637V65.6841H37.4563C38.6964 65.649 39.9016 65.2648 40.9332 64.5756L43.8132 58.0151C43.5721 56.4886 42.8054 55.0942 41.6457 54.0728C40.4859 53.0514 39.0058 52.4671 37.4611 52.4209ZM32.2506 61.8946H31.0711C30.3173 61.8946 29.5944 61.5952 29.0614 61.0622C28.5284 60.5292 28.2289 59.8063 28.2289 59.0525C28.2289 58.2987 28.5284 57.5758 29.0614 57.0428C29.5944 56.5098 30.3173 56.2104 31.0711 56.2104H32.2695L32.2506 61.8946ZM37.2432 61.8946H36.0684V56.2104H37.2669C37.6401 56.2104 38.0097 56.2839 38.3544 56.4267C38.6993 56.5695 39.0126 56.7789 39.2765 57.0428C39.5404 57.3067 39.7498 57.62 39.8926 57.9648C40.0355 58.3097 40.109 58.6792 40.109 59.0525C40.109 59.4257 40.0355 59.7953 39.8926 60.1401C39.7498 60.4849 39.5404 60.7982 39.2765 61.0622C39.0126 61.326 38.6993 61.5354 38.3544 61.6783C38.0097 61.8211 37.6401 61.8946 37.2669 61.8946H37.2432Z",
    fill: "#EF640F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1063 52.4209H47.8669L41.2969 67.5788H45.3611L46.1758 65.6841H52.0969V67.5788H55.8863V52.4209H52.1063ZM52.1063 61.8946H47.8432L50.2874 56.2104H52.1016L52.1063 61.8946Z",
    fill: "#EF640F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3487 52.4209L65.0981 55.3056L63.8855 58.1004H61.2802V52.4209H57.4766V67.5788H61.2802V61.8993H63.8855L65.0981 64.6941L66.3487 67.5788H70.4176L67.1302 59.9998L68.7692 56.2198L70.3845 52.4209H66.3487Z",
    fill: "#EF640F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9648 52.4209L91.9554 52.4351L85.6505 61.1414V52.4209H81.8516V67.5788H85.6505H85.6552L91.9554 58.8772V67.5788H95.7543V52.4209H91.9648Z",
    fill: "#EF640F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8772 52.4209H70.3667L68.7656 56.2198H73.1804V67.5788H76.984V56.2198H80.224L81.8772 52.4209Z",
    fill: "#EF640F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8754_33478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 15.1579,
    fill: "white",
    transform: "translate(24 52.4209)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactsLogo);
export default __webpack_public_path__ + "static/media/facts-logo.f92d7cfb901ae0355c2167c3a693a1bb.svg";
export { ForwardRef as ReactComponent };